var styles = {"box":"CryptoStatisticList_box_1xhui_1","list":"CryptoStatisticList_list_1xhui_7","search":"CryptoStatisticList_search_1xhui_10","crypto":"CryptoStatisticList_crypto_1xhui_20"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
